"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Greenhouses = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../render/CardRenderer");
var Size_1 = require("../render/Size");
var Greenhouses = (function (_super) {
    __extends(Greenhouses, _super);
    function Greenhouses() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.GREENHOUSES,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.BUILDING],
            cost: 6,
            metadata: {
                cardNumber: '096',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.plants(1).slash().city(Size_1.Size.SMALL).any;
                }),
                description: 'Gain 1 plant for each city tile in play.',
            },
        }) || this;
    }
    Greenhouses.prototype.play = function (player) {
        player.addResource(Resources_1.Resources.PLANTS, player.game.getCitiesInPlay(), { log: true });
        return undefined;
    };
    return Greenhouses;
}(Card_1.Card));
exports.Greenhouses = Greenhouses;
//# sourceMappingURL=Greenhouses.js.map